





















































































import { Vue, Component } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import * as amplitude from 'amplitude-js';
import {
  PromoCardFullDTOStatusEnum,
  PromoPictDTO,
  StoryAdminDTO,
} from '@/api';
import services from '@/services';
import { throwError } from '@/utils';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import Upload from '@/components/common/Upload.vue';
import Promo from '@/components/PromoPreview.vue';
import Story from '@/components/StoryPreview.vue';

@Component({
  name: 'promo-card-edit',
  components: {
    UserMenu,
    MainNavbar,
    Upload,
    Promo,
    Story,
  },
})
export default class PromoCardEditPage extends Vue {
  $refs!: {
    form: ElForm
  }

  loading = false;

  images: PromoPictDTO[] = [];

  stories: StoryAdminDTO[] = [];

  visibleStories = false;

  form = {
    status: PromoCardFullDTOStatusEnum.DRAFT,
    title: '',
    extraTitle: '',
    backgroundPictName: '',
    textColorHex: '333333',
    startFromMillis: new Date().valueOf(),
    endFromMillis: new Date().valueOf(),
    goToLink: '',
  }

  get statuses() {
    return Object.values(PromoCardFullDTOStatusEnum);
  }

  async created() {
    amplitude.getInstance().logEvent('Открыта страница промо-карточки', this.$route.params.id);

    try {
      this.loading = true;
      if (this.$route.params.id != null) {
        const { data: card } = await services.promoCardApi()
          .promoCardEndpointGetCard(Number(this.$route.params.id));
        this.form = { ...this.form, ...card };
      }
      const { data: images } = await services.promoCardApi().promoCardEndpointGetPictures();
      this.images = images;
      const { data: stories } = await services.storiesApi().storiesEndpointGetStories();
      this.stories = stories;
    } catch (e) {
      throwError('Ошибка')(e);
    } finally {
      this.loading = false;
    }
  }

  // async byImageFile(files: File[]) {
  //   const file = files[0] || null;
  //   if (file) {
  //     this.loading = true;
  //     try {
  //       // const binary = await fileReader(file);
  //       // const { data } = await axios.post<ImproveImageDTO>(`https://rest.styleconcierge.ru/api/service/improveImg/${file.name}`, binary, {
  //       //   headers: { 'Content-Type': 'application/octet-stream',
  //       // Authorization: `Bearer ${getAuthToken()}` },
  //       // });
  //     } catch (e) {
  //       console.error(e);
  //       // this.visible = false;
  //       this.$notify({ title: 'Ошибка! Обратитесь к администратору',
  // message: e, type: 'error' });
  //     } finally {
  //       this.loading = false;
  //     }
  //   }
  // }

  get previewOption() {
    return {
      title: this.form.title,
      extraTitle: this.form.extraTitle,
      backgroundPictName: this.images
        .find(image => image.name === this.form.backgroundPictName)?.url,
      textColorHex: this.form.textColorHex,
    };
  }

  setStories({ id }: {id: number}) {
    this.form.goToLink = `stylemate://stories/${id}`;
    this.visibleStories = false;
  }

  openStoriesModal() {
    this.visibleStories = true;
  }

  submit() {
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.loading = true;
        services.promoCardApi().promoCardEndpointStoreCard(
          this.$route.params.id != null ? Number(this.$route.params.id) : undefined,
          this.form.title,
          this.form.extraTitle,
          this.form.textColorHex,
          this.form.goToLink,
          this.form.backgroundPictName,
          this.form.startFromMillis,
          this.form.endFromMillis,
          this.form.status,
        )
          .then(() => {
            amplitude.getInstance().logEvent('Сохранение истории', this.form);
            this.$router.push({ name: 'promo-cards' });
          })
          .catch((e) => {
            this.$message.error(e);
          })
          .finally(() => { this.loading = false; });
      }
    });
  }
}
